import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import { getPaddingsClassFromData } from "@/utils/utils"
import { generateUrls } from "@/components/WhatWeDoCategoryPageGridCards"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import styled from "styled-components"
import Grid from "@/components/common/Cards/Grid"
import List from "@/components/common/Cards/List"

const ItemsContainer = styled.div`
	&.paddings {
		padding: 0 var(--paddingX);
	}
`

const DISPLAY_FORMATS = {
	LIST: "list",
	GRID: "grid",
}

const COMPONENTS_MAP = {
	// [DISPLAY_FORMATS.GRID]: dynamic(() => import("@/components/common/Cards/Grid"), {
	// 	ssr: false,
	// 	loading: (props) => <Loading {...props} />,
	// }),
	// [DISPLAY_FORMATS.LIST]: dynamic(() => import("@/components/common/Cards/List"), {
	// 	ssr: false,
	// 	loading: (props) => <Loading {...props} />,
	// }),
	[DISPLAY_FORMATS.GRID]: Grid,
	[DISPLAY_FORMATS.LIST]: List,
}

export default function ChoosenNewsModule({ data }) {
	const headerDescription = data?.headerDescription
	const paddings = getPaddingsClassFromData(data)
	const news = data?.news || []
	const displayFormat = data?.displayFormat || DISPLAY_FORMATS.LIST

	const formattedNews = generateUrls(news)
	const Component = COMPONENTS_MAP[displayFormat]

	return (
		<div className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<ItemsContainer className={displayFormat === DISPLAY_FORMATS.GRID ? "paddings" : ""}>
				<Component data={formattedNews} smallCover horizontalCards date />
			</ItemsContainer>
		</div>
	)
}